import { zdarKidsCustomCiphers } from '../zdarKidsGameCustomCiphers';
import audio from '../../../../assets/audio/kids-tracks/Text6.mp3';

export const step7pond = {
    id: 7,
    title: 'Rybník',
    taskText: `
        <p>
            Proč se ten pejsek zastavil, na co se to dívá? Hraběnku tu nikde nevidím... 
            Aha dívá se na ten rybník. Chodí se sem koupat, tohle psí nadšení pro vodu nikdy nepochopím. 
            Vidíš ale ten čurbes ve vodě? Myslím, že bychom se mohli zastavit a pomoct rybník trochu vyčistit. 
            Zvládneš poznat, co do rybníka patří a co ne? 
        </p>
    `,
    cipher: {
        label: 'Úkol',
        custom: zdarKidsCustomCiphers.pond,
    },
    continueButtonText: 'Pokračovat',
    audio: audio,
    points: true,
    hints: [
        {
            text: 'Do rybníka nepatří nákupní taška, plechovka ani autíčko',
        },
    ],
};
